import React from 'react'
import { Autocomplete, TextField } from '@mui/material'

interface OrgOption {
  id: number
  name: string
  levelId?: number
}

interface Props<T extends OrgOption> {
  label: string
  options: T[]
  value: T | null
  onChange: (value: T | null) => void
  disabled?: boolean
  loading?: boolean
}

export function ExecOrgAutocomplete<T extends OrgOption> ({
  label,
  options,
  value,
  onChange,
  disabled = false,
  loading = false
}: Props<T>): React.ReactElement {
  return (
    <Autocomplete
      disabled={disabled}
      options={options}
      loading={loading}
      getOptionLabel={option => option.name ?? ''}
      value={value}
      onChange={(_, next) => { onChange(next) }}
      isOptionEqualToValue={(option, selected) => option.id === selected.id}
      renderOption={(props, option) => (
        <li {...props} style={{ paddingLeft: ((option.levelId ?? 1) - 1) * 12 + 16 }}>
          {option.name}
        </li>
      )}
      renderInput={params => <TextField {...params} label={label}/>}
    />
  )
}
